// Remove duplicate $jq definition and ensure proper scoping
if (typeof $jq === 'undefined') {
  var $jq = jQuery.noConflict();
}


if ($jq(window).width() >= 768) {
  let lastUrl = location.href;
  if (lastUrl.indexOf("/collections/") >= 0) {
    var height = window.innerWidth * 0.3;
    var copyHeight = document.querySelector("#measure-me")?.offsetHeight || 0;

    var difference = height - copyHeight;
    difference = difference / 2;
    if (document.querySelector("#measure-me")?.style)
      document.querySelector("#measure-me").style.marginTop = difference + "px";
  }
}

//NT custom code for multivalue options
// Getting only unique filter values.
$jq(document).ready(function () {
  $jq(".tdf_img").prop("disabled", true);

  // blur function
  blurry();
  // check url on load
  onUrlChange();
  // removing default disabled values

  $jq(".facets__item input").each(function () {
    $jq(this).removeAttr("disabled");
  });

  // sleep function
  function sleep(num) {
    let now = new Date();
    let stop = now.getTime() + num;
    while (true) {
      now = new Date();
      if (now.getTime() > stop) return;
    }
  }

  // trigger options mobile
  $jq(document).on("change click", ".mobile-facets__item input", function () {
    if ($jq(this).is(":checked")) {
      var valuez = $jq(this).attr("value");
      $jq(".mobile-facets__item input").each(function () {
        var datas = $jq(this).attr("value");
        // console.log(datas);
        if (datas.indexOf(",") >= 0) {
          if (datas) {
            if (datas.indexOf(valuez) >= 0) {
              // console.log('found');
              $jq(this).prop("checked", true);
              $jq(this).addClass("hide-before");
            }
          }
        }
      });
    } else {
      var valuez = $jq(this).attr("value");
      $jq(".mobile-facets__item input").each(function () {
        var datas = $jq(this).attr("value");
        //console.log(datas);
        if (datas.indexOf(",") >= 0) {
          if (datas) {
            if (datas.indexOf(valuez) >= 0) {
              // console.log('found');
              $jq(this).prop("checked", false);
              $jq(this).removeClass("hide-before");
              //openFilters ();
            }
          }
        }
      });
    }
  });

  // trigger options Desktop
  $jq(document).on("change click", ".facets__item input", function () {
    if ($jq(this).is(":checked")) {
      var valuez = $jq(this).attr("value");
      $jq(".facets__item input").each(function () {
        var datas = $jq(this).attr("value");
        //console.log(datas);
        if (datas.indexOf(",") >= 0) {
          if (datas) {
            if (datas.indexOf(valuez) >= 0) {
              // console.log('found');
              $jq(this).prop("checked", true);
              $jq(this).addClass("hide-before");
            }
          }
        }
      });
    } else {
      var valuez = $jq(this).attr("value");
      $jq(".facets__item input").each(function () {
        var datas = $jq(this).attr("value");
        //console.log(datas);
        // if(datas.indexOf(',') >=0 ){
        if (datas) {
          if (datas.indexOf(valuez) >= 0) {
            // console.log('found' +datas );
            $jq(this).prop("checked", false);
            // openFilters ();
          }
        }
        //  }
      });
    }
  });

  let lastUrl = location.href;
  if (lastUrl.indexOf("/collections/") >= 0) {
    new MutationObserver(() => {
      let result = document.getElementById("FacetFiltersForm");
      const url = location.href;
      if (url !== lastUrl) {
        lastUrl = url;
        onUrlChange();
        console.log(result.hasAttribute("open"));
        if (result.hasAttribute("open") === false) {
          // openFilters ();
        }
      }
    }).observe(document, { subtree: true, childList: true });
  }

  function onUrlChange() {
    //alert('URL changed!', location.href);
    //console.log('worked!!');
    var url = location.href;
    var res = url.split("&");
    //console.log(res);
    foo = 0;
    for (i = 0; i < res.length; i++) {
      if (res[i].indexOf("concerns") >= 0 || res[i].indexOf("price") >= 0) {
        console.log(res[i]);
        if (res[i].indexOf("%2C") <= 0) {
          //foo++;
          var final = res[i].split("=");
          NewFinal = decodeURIComponent(final[1]);
          NewFinal = NewFinal.replace("+", " ");
          NewFinal = NewFinal.replace("+", " ");
          console.log(NewFinal);
          $jq(".unique_labels input").each(function () {
            var dati = $jq(this).attr("value");
            if (dati.indexOf(NewFinal) >= 0) {
              $jq(this).prop("checked", true);
            }
          });
          $jq(".facets__item input").each(function () {
            var dati = $jq(this).attr("value");
            if (dati.indexOf(NewFinal) >= 0) {
              // console.log(dati);
              $jq(this).prop("checked", true);
            }
          });
        }
      }
    }
    var xpp = 0;
    $jq(".product_filter input").each(function () {
      if ($jq(this).is(":checked")) {
        xpp++;
      }
    });
    $jq(".unique_labels input").each(function () {
      if ($jq(this).is(":checked")) {
        foo++;
      }
    });

    xpp = xpp / 2;
    foo = foo / 2;
    //console.log('foo is '+ foo +' and xpp is ' + xpp);
    $jq(".counter_place").text(foo + xpp);
  }

  // CLear button functionality
  $jq(".clear_button").hide();
  var foo = 0;
  $jq(".facets__item input").each(function () {
    if ($jq(this).is(":checked")) {
      foo++;
      //console.log(foo);
    }
    if (foo >= 1) {
      $jq(".clear_button").show();
    } else {
      $jq(".clear_button").hide();
    }
  });

  $jq(".facets__item input").change(function () {
    var foo = 0;
    $jq(".facets__item input").each(function () {
      if ($jq(this).is(":checked")) {
        foo++;
        //console.log(foo);
      }
      if (foo >= 1) {
        $jq(".clear_button").show();
      } else {
        $jq(".clear_button").hide();
      }
    });
  });

  // menu elements on hover
  $jq("details-disclosure details summary").hover(function () {
    var thisId = $jq(this).parent().attr("id");
    $jq("details-disclosure details").each(function () {
      $jq(this).removeAttr("open");
    });
    $jq("#" + thisId).removeClass("hide_after");
    $jq("#" + thisId + " .header__submenu").removeClass("z-index");
    $jq("#" + thisId).attr("open", "open");
  });

  $jq("span.right_icon").click(function () {
    var parentId = $jq(this).parent().attr("id");
    number = parentId.replace(/\D/g, ""); // a string of only digits, or the empty string
    //number = parseInt(parentId, 10); // now it's a numeric value
    $jq(this).parent().addClass("z-index");
    $jq("#Details-HeaderMenu-" + number).addClass("hide_after");
    $jq("#Details-HeaderMenu-" + number).removeAttr("open", "open");

    // $jq(this).parent().hide();
    //console.log('#Details-HeaderMenu-' + number);
  });

  // Hide menu on hover out
  const hiding = [
    "#index",
    ".product__info-wrapper",
    ".header__icons",
    ".link--text",
    ".logo-header",
    "#MainContent",
    ".header--has-menu",
    ".header-custom",
    ".header-wrapper",
  ];
  for (const hihi of hiding) {
    $jq(hihi).hover(function () {
      $jq("details-disclosure details").each(function () {
        $jq(this).removeAttr("open");
      });
    });
  }

  // On hover out hide menu
  $jq(".header__inline-menu").mouseleave(function (e) {
    //console.log('hovered out!');
    var x = e.pageX - $jq(".header__inline-menu").offset().left;
    // -2 , 699
    //console.log(x);
    //console.log(e.pageY - $jq(window).scrollTop());
    if (e.pageY - $jq(window).scrollTop() <= 110) {
      if (x > 699 || x < -1) {
        //console.log('worked hiding!!');
        $jq("details-disclosure details").each(function () {
          $jq(this).removeAttr("open");
        });
      }
    }
  });

  if (document.querySelector(".rc-container-wrapper") === null) {
    $jq(".product-form__submit").removeAttr("disabled");
  }
});

var checkExist = setInterval(function () {
  // Check if RC widget exists on the page, if not, check again in 100ms
  if (document.querySelector(".rc-container-wrapper")) {
    // Clear interval so this only runs once
    clearInterval(checkExist);

    // Variant title to prevent sub on
    let noSub = "Single";

    // DOM elements
    let hidePrice = document.querySelector(".price__wrapper");
    let variants = document.querySelectorAll(
      ".product__section .product-form__input input"
    );
    let rechargeForm = document.querySelector(".rc-container-wrapper");
    let initialCheckedValue = document.querySelector(
      ".variants__picker input:checked"
    );
    // hide regular price :
    hidePrice.classList.add("hidden_regular");

    // For each variant option
    variants.forEach((variant) =>
      // Add an onclick event listener

      variant.addEventListener("click", (e) => {
        // If the variant selected matches the no subscription variable
        console.log(e.target.value);
        var vv = e.target.value.toString();
        hidePrice.classList.add("hidden_regular");
        if (vv.indexOf(noSub) >= 0) {
          // Hide RC widget and click first/one time option
          if (rechargeForm) {
            rechargeForm.style.display = "none";
          }
          var rcInputEl = document.querySelector(
            ".rc_widget__option--onetime input"
          );
          if (rcInputEl) {
            rcInputEl.click();
          }
        } else {
          // Show RC widget
          if (rechargeForm) {
            rechargeForm.style.display = "block";
          }
        }
      })
    );

    // On first load
    var bb = "";
    if (initialCheckedValue) {
      bb = initialCheckedValue.value.toString();
    }
    //console.log(bb)
    hidePrice.classList.add("hidden_regular");
    if (bb.indexOf(noSub) >= 0) {
      // Hide RC widget and click first/one time option
      rechargeForm.style.display = "none";
      document.querySelector(".rc_widget__option--onetime input").click();
    } else {
      // Show RC widget
      rechargeForm.style.display = "block";
    }
  }

  // Changing recharge learn more
  $jq(".rc_popup__learn_more").attr("href", "/pages/subscription");
  $jq("#dummy-chat-button-iframe").css("bottom", "0");
  $jq(".chat-title").text("Chat");
}, 100);

// Changing yotpo h2 elements
var checkYotpo = setInterval(function () {
  let rechargeForm = document.querySelector(".rc-container-wrapper");
  $jq(".yotpo-header-title")
    .first()
    .replaceWith('<h3 class="yotpo-header-title y-label">WRITE A REVIEW</h3>');
  $jq(".yotpo-header-title")
    .last()
    .replaceWith('<h3 class="yotpo-header-title y-label">ASK A QUESTION</h3>');
  let lastUrl = location.href;
  if (
    lastUrl.indexOf("/products/") >= 0 ||
    lastUrl.indexOf("products_preview") >= 0
  ) {
    if (rechargeForm) {
      rechargeForm.style.display = "none";
    }
  }

  clearInterval(checkYotpo);
}, 1000);

// reviews page
$jq(document).ready(function () {
  setTimeout(function () {
    var url = location.href;
    //console.log('urrll' +url);
    var nav = $jq("#reviews_place");
    if (url.indexOf("#reviews_place") >= 0) {
      $jq("html, body").animate(
        {
          scrollTop: nav.offset().top,
        },
        1000
      );
    }
    $jq(".star-clickable").addClass("xxwwa");
  }, 1000);

  setTimeout(function () {
    $jq(".tdf_img").prop("disabled", true);
    $jq(".tdf_img").hide();
  }, 1000);
});

//loader functionality

$jq(document).ready(function () {
  var url = location.href;
  if (url.indexOf("/collections/all") >= 0) {
    setTimeout(function () {
      const loader = document.querySelector(
        ".collection-with-fixed-filtering .loader"
      );
      loader.style.display = "none";
    }, 500);
  }
});

function openFilters() {
  const filter = document.querySelector("facet-filters-form .js-form__filters");
  const product_grid = document.querySelector("#product-grid");
  const loadMore = document.querySelector(".load-more_wrap");

  const w = document.querySelector("#product-grid .grid__item").offsetWidth;
  //console.log(w);
  filter.setAttribute("open", "");
  product_grid.setAttribute("filters-open", "");

  filter.style.width = `${w}px`;

  product_grid.style.width = `${product_grid.offsetWidth - w - 30}px`;
  product_grid.style.marginLeft = "auto";
  product_grid.style.marginRight = "0";
}

window.addEventListener("load", function () {
  let current = window.location.href;
  const windowWidth = $jq(window).width();
  if (
    current.indexOf("/collections/all") >= 0 &&
    windowWidth >= 750 &&
    current.indexOf("filter.") <= 0
  ) {
    //  openFilters ();
    //loader();
  }
});

// blur soldout on quickshop hover
function blurry() {
  $jq(".quick__shop-btn").hover(
    function () {
      $jq(this).parent().find(".knesko-card__badge").addClass("blur");
    },
    function () {
      $jq(this).parent().find(".knesko-card__badge").removeClass("blur");
    }
  );
}

// Product page scroll up and down.

var lastScrollTop = 0;
var positionDown = true;
var positionUp = true;
const windowWidth = $jq(window).width();
let current = window.location.href;
if (
  current.indexOf("/products/") >= 0 ||
  current.indexOf("products_preview") >= 0
) {
  $jq(window).scroll(function (e) {
    if (windowWidth >= 1200) {
      var st = $jq(this).scrollTop() + 1;
      if (st > lastScrollTop) {
        if (positionDown) {
          e.preventDefault();
          $jq(".product__info-container--sticky").stop().animate(
            {
              scrollTop: 1200,
            },
            2000
          );
          positionDown = false;
          positionUp = true;
        }
      } else {
        if (st >= 300) {
          if (positionUp) {
            e.preventDefault();
            $jq(".product__info-container--sticky").stop().animate(
              {
                scrollTop: 0,
              },
              2000
            );
            positionUp = false;
            positionDown = true;
          }
        }
      }
      lastScrollTop = st;
    }
  });
}

// recharge no customer found page add return to account
if (current.indexOf("no_shopify_customer_found/") >= 0) {
  $jq(".rc_title-bar").append(
    "<p><a href='/account'>Return to account</a></p>"
  );
}

/*
 var  delta = true;
$jq('.section-template--15746216067285__main').on('scroll mouse', function(e){
   if ( delta == true ){
    //var finaldelta = delta * 400;
    console.log(delta);
    //$jq('.product--stacked .product__info-container--sticky').animate({scrollTop:finaldelta}, '200', 'swing');
    //$jq('.product--stacked .product__info-container--sticky').scrollTop(finaldelta);
    $jq('.section-template--15746216067285__main').animate({
        scrollTop: 1000
      }, 1000);
    e.preventDefault();
    delta = false;
   }*/

$jq(".control").click(function () {
  $jq(".video-el").trigger("play");
  $jq(".popup-video").first().fadeIn("slow");
  $jq(".popup-video").css("display", "block");
});
$jq(".popup-video span").click(function () {
  $jq(".popup-video").fadeOut("slow");
  $jq(".video-el").trigger("pause");
  $jq(".popup-video").css("display", "none");
});

// if ($jq(window).width() < 426){
//
//     $jq(".anchor.details").click(function(){
//         var y = $jq(window).scrollTop();
//         $jq('html, body').animate({ scrollTop: y + 950 },1000)
//     });
//
// }

// sticky add to cart button in product page.......
if ($jq(window).width() < 769) {
  var sticky = 0; //1500;

  $jq(window).scroll(function () {
    var currentScroll = $jq(window).scrollTop();
    if (currentScroll >= sticky) {
      $jq(".product .product-form__buttons").css({
        position: "fixed",
        bottom: "10px",
        left: "50%",
        width: "calc(100% - 20px)",
        transform: "translate(-50%, 0)",
        background: "#fcfbf8",
      });

      $jq(".product .product-form__buttons button").css({
        width: "100%",
        margin: "auto",
        display: "block",
      });
    } else {
      $jq(".product .product-form__buttons").css({
        position: "static",
        transform: "unset",
        left: "unset",
        width: "100%",
        background: "",
      });
      $jq(".product .product-form__buttons button").css({
        width: "",
        margin: "",
        display: "block",
      });
    }
  });

  $jq(function () {
    $jq(window).scroll(function () {
      var scroll = $jq(window).scrollTop();

      if (scroll >= $jq("footer").offset().top - $jq("footer").height()) {
        $jq(".product .product-form__buttons .product-form__submit").css(
          "background-color",
          "white"
        );
        $jq(".product .product-form__buttons .product-form__submit span").css(
          "color",
          "black"
        );
      } else {
        $jq(".product .product-form__buttons .product-form__submit span").css(
          "color",
          "white"
        );
        $jq(".product .product-form__buttons .product-form__submit").css(
          "background-color",
          "black"
        );
      }
    });
  });
}
// ..........................

// Scroll down to where it stopped
$jq(document).ready(function () {
  $jq(".custom-option").click(function () {
    $jq(this).addClass("choosen");
  });
  $jq(".looking__to-wrapper:not(hidden)").click(function () {
    if ($jq(this).find(".custom-select").hasClass("open")) {
      var indx = $jq(this).find(".selected").index();
      //var text = $jq(this).text();
      console.log(indx);
      $jq(".custom-options").animate(
        {
          scrollTop: indx * 30,
        },
        500
      );
    } else {
      $jq(".custom-options").animate(
        {
          scrollTop: 0,
        },
        100
      );
    }
  });
});

$jq(document).ready(function () {
  $jq(".subuscription_product_grid .product__card").hover(function () {
    $jq(this).find(".secondary_image").toggleClass("hidden");
  });
});

const DetailsFirst = `
    position: relative;
	top: -24px;
	left: 50px;
  `;
const DetailsSecond = `
    position: relative;
	top: -24px;
	left: 60px;
  `;
const DetailsThird = `
    position: relative;
	top: -24px;
	left: 80px;
  `;
const DetailsLast = `
    position: relative;
	top: -24px;
	left: 50px;
  `;
const widthfull = `
	width:100%
   `;
const menuListFlex = `
    display: flex;
    justify-content: flex-end;
	`;
const ProductFlex = `
	align-items: flex-end;
	`;
// check browser version

navigator.sayswho = (function () {
  var ua = navigator.userAgent;
  var tem;
  var M =
    ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) ||
    [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return "IE " + (tem[1] || "");
  }
  if (M[1] === "Chrome") {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
  return M.join(" ");
})();

//console.log(navigator.sayswho); // outputs: `Chrome 62`
if (navigator.sayswho.indexOf("Safari") >= 0) {
  var version = navigator.sayswho.split(" ");
  version = parseInt(version[1]);
  console.log("Safari version " + version);
  // all safari versions

  if (version <= 14) {
    document
      .querySelector(".header-submenu-for-Shop")
      .classList.add("submenu-safari");
    document
      .querySelector(".header-submenu-for-Blog")
      .classList.add("submenu-safari");
    document
      .querySelector(".shop-menu-featured-products")
      .classList.add("full-width-safari");
    document
      .querySelector("#Details-HeaderMenu-1")
      .classList.add("safari-padding");
    document
      .querySelector("#Details-HeaderMenu-2")
      .classList.add("safari-padding");
    document
      .querySelector("#Details-HeaderMenu-3")
      .classList.add("safari-padding");
    document.querySelector("#Details-HeaderMenu-1 .header-caret-icon").style =
      DetailsFirst;
    document.querySelector("#Details-HeaderMenu-2 .header-caret-icon").style =
      DetailsSecond;
    document.querySelector("#Details-HeaderMenu-3 .header-caret-icon").style =
      DetailsThird;
    document.querySelector(".shop-menu-featured-products").style = widthfull;
    if (document.querySelector("#HeaderMenu-MenuList-1")) {
      document.querySelector("#HeaderMenu-MenuList-1").style = menuListFlex;
    }
    if (document.querySelector(".quantity_plus_product")) {
      document.querySelector(".quantity_plus_product").style = ProductFlex;
    }

    // only 14 and less safari version
    //document.querySelector('.classnam').classList.add("x")
  } else {
    if (document.querySelector("#HeaderMenu-MenuList-1")) {
      document.querySelector("#HeaderMenu-MenuList-1").style = menuListFlex;
    }

    if (document.querySelector(".quantity_plus_product")) {
      document.querySelector(".quantity_plus_product").style = ProductFlex;
    }
    // some issue with safari submit form :
    //var form = document.querySelector('.shopify-localization-form');
  }
}

$jq("#CountryList .disclosure__item a").on("click", function () {
  console.log("this has been clicked");
  //$jq(this)
  // .parents('form')
  //.submit();
});

// remove how to use section from serum products
// $jq(document).ready(function() { // it's now disabled because of request: https://app.clickup.com/t/8677ruvbh
//     if (window.location.href.indexOf("serum") > -1) {
//         $jq('.how-to-use-section').css('display','none');
//         $jq('.how_to_use').css('display','none');
//     }
// });

// // // only for mobile
// var isMobile = false; //initiate as false
// // device detection
// if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
//     || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
//     isMobile = true;
//     $jq('.grid__item').css('max-width','100% !important');
//     $jq('.card .quick__shop-btn').css('left','35%');
// }

// $jq(document).ready(function() {
//     var target = document.querySelector(".header__icon--cart");
//     var cartItem = document.querySelector(".cart_items");
//     var cartNote = document.querySelector(".cart_note");
//     var cartProducts = document.querySelector(".cart_items_products");
//     var singleItem = document.querySelectorAll(".cart-item");

//     target.addEventListener("mouseover", mOver, false);

//     function mOver() {
//         if( !cartNote.classList.contains('hidden') ) {
//             var notification = document.getElementById('cart-notification');

//             jQuery.getJSON('/cart.js', function(cart) {
//                 console.log(cart);
//                 var qty =  cart.item_count;
//                 cartProducts.innerHTML='';
//                 if(qty>=1){
//                     for(var i = 0; i <  cart.items.length; i++) {
//                         var image = cart.items[i].featured_image.url.split('.jpg');
//                         image = image[0] + '_140x.jpg';
//                         var name = cart.items[i].options_with_values[0].name;
//                         var value = cart.items[i].options_with_values[0].value;
//                         if( name.indexOf('Title')>= 0 ){
//                             name = '';
//                         }
//                         if(value.indexOf('Title')>= 0 ){
//                             value = '';
//                         }
//                         if (cart.items[i].selling_plan_allocation ){
//                             var sellingPlan = '<p class="product-option">'+cart.items[i].selling_plan_allocation.selling_plan.name +'</p>'

//                         }else{
//                             var sellingPlan = ''
//                         }

//                         cartProducts.innerHTML += '<div id="cart-notification-product-'+cart.items[i].id +'" class="cart-item ajaxed_item">' +
//                                                   '<div class="cart-notification-product__image global-media-settings">' +
//                                                   '<img src="'+ image +'" alt="'+cart.items[i].featured_image.alt+'" height="86" width="70" loading="lazy">' +
//                                                   '</div>' +
//                                                   '<div>' +
//                                                   '<h3 class="cart-notification-product__name h6">'+ cart.items[i].product_title +'</h3>' +
//                                                   '<dl> <div class="product-option"><dt>'+ name +' </dt><dd>'+ value +'</dd></div></dl> '+ sellingPlan +
//                                                   '<div class="cart-notification-product__price-qty">' +
//                                                   '<div class="cart-notification-product__qty h6">Quantity: ' + cart.items[i].quantity +'</div>'+
//                                                   '<div class="cart-notification-product__price h6">Price: $' + (cart.items[i].price/100) + '</div>'+
//                                                   '</div>' +
//                                                   '</div>' +
//                                                   '</div> ' ;
//                     }
//                 }else{
//                     console.log('empty cart')
//                     cartItem.innerHTML = 'Your cart is empty.';
//                 }

//                 notification.classList.add('active');
//                 cartProducts.classList.remove('hidden');
//                 cartNote.classList.add('hidden');
//                 cartItem.classList.remove('hidden');
//                 cartProducts.classList.remove('hidden');
//                 jQuery(notification).one('transitionend', function(){
//                     notification.focus();
//                     trapFocus(notification);
//                 });
//             });

//             jQuery(notification).one('mouseleave', function(){
//                 notification.classList.remove('active');
//                 cartNote.classList.remove('hidden');
//             });
//         }
//     }

//     $jq('.cart-notification__close').click(function(){
//         $jq(".cart_note").removeClass('hidden');
//         $jq('.ajaxed_item').remove();
//     });

// });

// custom grid for collections

// if($jq('.collection-view-hero__title').find(':not(:contains("All Products"))').length > 0){
//      $jq("#product-grid").addClass("collection-grid-custom");
// }

if ($jq(".collection-view-hero__title").text().indexOf("All Products") === -1) {
  $jq("#product-grid").addClass("collection-grid-custom");
}
// ...........

$jq(
  "#Details-3-template--15746165440725__product-grid .list-unstyled .unique_labels .filter-item"
).each(function () {
  var dar = $jq(this).text();
  if (dar.indexOf("Under") >= 0) {
    $jq(this).parent().css("order", "0");
    $jq(this).parent().css("margin-top", "0");
  }
  if (dar.indexOf("$50 – $100") >= 0) {
    $jq(this).parent().css("order", "1");
  }
  if (dar.indexOf(" $150") >= 0) {
    $jq(this).parent().css("order", "2");
    $jq(this).parent().css("margin-top", "0.8rem");
  }
  if (dar.indexOf("$150 and") >= 0) {
    $jq(this).parent().css("order", "3");
  }
});

// same as above for mobile
$jq(
  "#FacetMobile-3-template--15746165440725__product-grid .list-unstyled .unique_labels .filter-item"
).each(function () {
  var dar = $jq(this).text();
  console.log("one item " + dar);
  if (dar.indexOf("Under") >= 0) {
    $jq(this).parent().css("order", "0");
    $jq(this).parent().css("margin-top", "2.4rem");
  }
  if (dar.indexOf("$50 – $100") >= 0) {
    $jq(this).parent().css("order", "1");
  }
  if (dar.indexOf(" $150") >= 0) {
    $jq(this).parent().css("order", "2");
  }
  if (dar.indexOf("$150 and") >= 0) {
    $jq(this).parent().css("order", "3");
  }
});

// remove how to use section from serum products
$jq(document).ready(function () {
  if (window.location.href.indexOf("search") > -1) {
    $jq(".product--search-results").css("display", "grid");
    if (window.location.href.indexOf("page") > -1) {
      if (window.location.href.indexOf("page=1") > -1) {
        console.log(window.location.href);
        $jq(".product--search-results").css("display", "grid");
      } else {
        $jq(".product--search-results").css("display", "none");
      }
    }
  }
});

/* manage reward botton to pop the popup */
/*redeem-points-extended */

const triggers = [
  ".redeem-points-extended",
  ".manage-rewards--link",
  ".redeem-ur-points",
];
for (const trigger of triggers) {
  $jq(trigger).click(function (e) {
    e.preventDefault();
    $jq(".swell-tab").trigger("click");
  });
}

// changes for our founder page
$jq(document).ready(function () {
  if (
    $jq(window).width() < 1000 &&
    window.location.href.indexOf("our-founder") > -1
  ) {
    $jq("#shopify-section-template--15865663062229__165567739845026006").css(
      "display",
      "none"
    );
    $jq(".rich-text__text").css("padding", "0");
    $jq("#Banner-template--15865663062229__1655676537b671d263").css(
      "height",
      "150px"
    );
  }
});

let bburl = location.href;

if (
  bburl.indexOf("/products/") >= 0 ||
  bburl.indexOf("products_preview") >= 0
) {
  $jq(document).ready(function () {
    $jq(".product__media-images").slick({
      dots: true,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: "linear",
      // initialSlide: 1,
      arrows: false,
      mobileFirst: true,
      customPaging: function (slider, i) {
        return '<div class="slide-dot">&nbsp;</div>';
      },
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            // initialSlide: 1,
            dots: false,
            asNavFor: ".slider-nav",
            swipe: false,
            draggable: false,
          },
        },
      ],
    });

    $jq(".slider-nav").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: ".product__media-images",
      dots: false,
      arrows: true,
      centerMode: true,
      focusOnSelect: true,
      prevArrow: $jq(".slider-nav_right-arrow"),
      nextArrow: $jq(".slider-nav_left-arrow"),
    });

    $jq(".variants__picker label").click(function () {
      if (!$jq(".variants__picker .tooltip").hasClass("hidden")) {
        $jq(".variants__picker .tooltip").addClass("hidden");
      }
    });

    $jq(".anchor.how_to_use").click(function () {
      $jq("html, body").animate(
        {
          scrollTop:
            $jq(".how_to_use-wrapper").offset().top -
            $jq("sticky-header.header-wrapper").height() -
            70,
        },
        2000
      );
    });

    $jq(".anchor.details").click(function () {
      $jq(".detailz_acc details").attr("open", "true");
      $jq(".detailz_acc summary").attr("aria-expanded", "true");
      if (window.innerWidth < 1200) {
        $jq("html, body").animate(
          {
            scrollTop:
              $jq(".detailz_acc").offset().top -
              $jq("sticky-header.header-wrapper").height() -
              70,
          },
          2000
        );
      } else {
        $jq("html, body").animate(
          {
            scrollTop:
              $jq(".detailz_acc").offset().top -
              $jq("sticky-header.header-wrapper").height(),
          },
          2000
        );
      }
    });

    $jq(".anchor.reviews").click(function () {
      $jq("html, body").animate(
        {
          scrollTop:
            $jq("#yotpo-reviews-main-widget").offset().top -
            $jq("sticky-header.header-wrapper").height(),
        },
        2000
      );
    });

    // $jq('.share__btn').click(function(){
    //     $jq('.share__btn').toggleClass('open')
    // })

    $jq(".product-form__buttons").click(function () {
      if ($jq(".product-form__submit").is(":disabled")) {
        $jq(".variants__picker .tooltip").removeClass("hidden");
      }
    });
  });
}

$jq(".tdf_img").click(function () {
  preventDefault();
});

// email frontend validator
function ValidateEmail(mail) {
  if (/^\w+([\.\+_-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
    return true;
  }
  return false;
}

function shouldRegisterFormBeDisabled(
  emailInput,
  passwordInput,
  errorMessageEl
) {
  if (
    emailInput.value.trim().length === 0 ||
    !ValidateEmail(emailInput.value)
  ) {
    emailInput.classList.add("invalid");
    errorMessageEl.innerHTML = "Please enter a valid email address";
    return true;
  }

  if (passwordInput.value.trim().length === 0) {
    passwordInput.classList.add("invalid");
    errorMessageEl.innerHTML = "please fill the password field";
    return true;
  }

  if (
    emailInput.value.trim().length > 0 &&
    ValidateEmail(emailInput.value) &&
    passwordInput.value.trim().length > 0
  ) {
    emailInput.classList.remove("invalid");
    passwordInput.classList.remove("invalid");
    errorMessageEl.innerHTML = "";
    return false;
  }

  return true;
}

let currentPage = window.location.href;
if (currentPage.indexOf("/account/") >= 0) {
  let error = document.querySelector("#RegisterForm-email-frontError");
  let input = document.querySelector("#RegisterForm-email");
  let passinput = document.querySelector("#RegisterForm-password");
  let submitController = document.querySelector("#submit-na");
  submitController.disabled = true;

  input.onfocus = function () {
    submitController.disabled = shouldRegisterFormBeDisabled(
      input,
      passinput,
      error
    );
  };

  input.onblur = function () {
    submitController.disabled = shouldRegisterFormBeDisabled(
      input,
      passinput,
      error
    );
  };

  passinput.onblur = function () {
    submitController.disabled = shouldRegisterFormBeDisabled(
      input,
      passinput,
      error
    );
  };

  passinput.oninput = function () {
    submitController.disabled = shouldRegisterFormBeDisabled(
      input,
      passinput,
      error
    );
  };
}
